// rsaUtils.js
import JSEncrypt from 'jsencrypt';
import main from '../main';
const publicKey='MIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQCn569kiXgYGC7aXJtsrvECX3Ab6RPrG5ToGQ2laY1xVjeowGZsVvudRZTn/JxPp8pySBoZOA9cWu96WZzpUUSD1yspZCJWUn8YBsCtjiI1Cku1yE84BZtmOHc1ptKjTWQiLYEgJrUOMfOAvqJ0fEFKAm+NxjZjbauIyS2YRIDQ1ub/wLRl0RR7U0HKk8KQlvxHV60amKUn5VNZZYKQSGeIT2zoyzYczXRhftn0ZMWxWLN/ps0UHY2Obi1B8kvl1ockhr/2jVNd6nDU3z4CVFjEEOCMpFmXPC3kUewXAIKEPHUEf1jRyajJkzZFUSoizHzr3nEP/RCIw0SggV4dLcMrAgMBAAECggEAG/Lf6i9L007rNaPmpz+zlH6IbcztaNxNfBj3gYpBZhVA7JEiO3R7K6GyeK8+4a9/bmh8F6iSPgBRDp+uE9RYQE3nvFsTsCTJTRmKpxkarpOJKLgwH5YnWOubRE4Bj/dI7LuAW/a1eqhr7QlOh29LeuNO6F2PHhvaSsmaEleMzbZC7PuypKW+/sjEGccGFtCzV5NnLicFJZS2LHvcmBeqsa7iv3LE0+/qOH+DB8ZAw6CI5SihgpyxCaamLHfssF2yuPyzENLHSpSxx5HZAmCFkcNtvwG+6BRqIyfkwm13djSpC15re17TdyCOMxg1mIgSHbNtDxtspQsOU9l0s5fi+QKBgQDV9uDbmxHniIWav3FlpqGgzHPj7Iyv9Q33p9Rr3g1A9wIVnbmDHtei3UWC5NJhUCRewTlaAuKwKUc3yBnvxiUAG5RaOb6K1c3XzT2sQ9TXUc8AQ5q/Ie/NQ547CS2Hr9+uhp4UTZgHwgUG/IgGksuBptzxS5jlvVHyTW9EkM7XfwKBgQDI5ExjzTOgZJmJCkNWRsxbZzUCqSAt4WQeQLa6SOfZKmjniUSFnTBdUocGxiMrhbY7OBdDcoTRLy+NR8O6kjPiQg4oT/7dPpciHfT0+u+tsriJPIqmUCSMkVqXBY75tfhOz16VjWi7ql419QXa3kYNgjfanksQPiHapU29WIrKVQKBgCZzC+tKzYfe56tsVbNfo1HjC7xcqNeB4PWtKiYMLDONb8l0o36ljziMLM6d0hR8s1x3uperRxNDB7JFeiu1XrbLPfiMwenvC+OI1VlcgyYCZIF2pJtOPOqVCR0wxAbLGxYgyM17OCPEwOSFgugzfvCYjMGrxRkb0VsKgUFACHt/AoGBAL69TO6BeiAzBDhCn1a+l++9GW7yR9RoKZgz14seB8yA4OPdyEqYycAByKSc4e3D4hduFWB7zjGTfLHGzsdJY6vTDgAmnBVTBUpmaRtlWsZwZ5gd/IMWmu1AYWP86hicNywU5nhWsHdmtlbC0xFRc/AFkKSpIRpF8/zWcO5zsCuVAoGBAI5YsINpKM066AbhPcHgUNl/pWgqAP1mbzsPoQAqIysI+jga/fcqG6ylcMenWNvsGz2b3QH30ScnO/eRYZb7ElM2g+2zWumSLIawIkUIFU7roMUdF37LYJSVrEzNskWUlNP/MmZn9BgVWxARb4rNBoq8zHyXr9H8EMD4eWjvn/pr'
const publicKeySm='iVP9ChZIo41F58y9pGAq2MwBZvOPVWyH5jcRT35PVcs'
/**
 * RSA 加密
 * @param {string} plainText - 明文
 * @param {string} publicKey - 公钥（PEM 格式）
 * @returns {string} - 加密后的 Base64 字符串
 */
export function encrypt(plainText:any) {
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(publicKey);
  return encryptor.encrypt(plainText);
}
/**
 * SM4 加密
 * @param {string} plainText - 明文
 * @param {boolean} isHex - 是否返回16进制字符串，默认为true
 * @returns {string} - 加密结果
 */

// 获取当前时间并格式化为 yyyy-MM-dd hh:23:34:39
export function getCurrentTimestamp(): string {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = '23'; // 固定分钟为23
  const seconds = '34'; // 固定秒为34
  const millisecond = '39'; // 固定秒为34

  return `${year}${month}${day}${hours}${minutes}${seconds}${millisecond}`;
}
export function insertAtPosition(str: string, insert: string, position: number) {
  if (position > str.length) position = str.length;
  if (position < 0) position = 0;
  return str.slice(0, position) + insert + str.slice(position);
}
// 手机验证码加密
export function generateSecretKey() {
  const randomString = main?.privateKey || '';
  return randomString
}
// 生成32位随机字符串
export function generateRandomString(length: number): string {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}